import axios from "axios";
import { useEffect } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../url/api";
const PaymentFailed = () => {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const session_id = urlParams.get("session_id");

  const callPaymentFailedApi = async () => {
    const response = await axios.get(
      `${API_URL}validate/checkout-status/${session_id}/`
    );
    console.log("Form submitted successfully:", response.data);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 3000);
    callPaymentFailedApi();
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="flex items-center align-center justify-center mb-4">
          <IoMdCloseCircle className="text-6xl text-red-500" />
        </div>
        <h1 className="text-3xl font-bold mb-2 text-center">Payment Failed!</h1>
        <p className="text-gray-600 text-center">
          Please retry after sometime, Thank you for your payment. You will be
          redirected to the dashboard shortly.
        </p>
      </div>
    </div>
  );
};

export default PaymentFailed;
